import { createTheme } from '@mui/material/styles';
import { AppColors } from './AppColors';
import { AppTextsFontSize, AppTextsFontWeight } from './AppTexts';

const useCustomTypography = createTheme({
  typography: {
    number: {
      fontSize: AppTextsFontSize.SIZE_NUMBER,
      fontWeight: AppTextsFontWeight.WEIGHT_BOLD,
    },
    title: {
      fontSize: AppTextsFontSize.SIZE_TITLE,
      fontWeight: AppTextsFontWeight.WEIGHT_LIGHT,
      fontFamily: "Comfortaa",
    },
    title_medium: {
      fontSize: AppTextsFontSize.SIZE_TITLE,
      fontWeight: AppTextsFontWeight.WEIGHT_MEDIUM,
      fontFamily: "Comfortaa",
    },
    title_bold: {
      fontSize: AppTextsFontSize.SIZE_TITLE,
      fontWeight: AppTextsFontWeight.WEIGHT_BOLD,
      fontFamily: "Comfortaa",
    },
    subtitle: {
      fontSize: AppTextsFontSize.SIZE_SUBTITLE,
      fontWeight: AppTextsFontWeight.WEIGHT_LIGHT,
      fontFamily: "Comfortaa",
    },
    subtitle_medium: {
      fontSize: AppTextsFontSize.SIZE_SUBTITLE,
      fontWeight: AppTextsFontWeight.WEIGHT_MEDIUM,
      fontFamily: "Comfortaa",
    },
    subtitle_bold: {
      fontSize: AppTextsFontSize.SIZE_SUBTITLE,
      fontWeight: AppTextsFontWeight.WEIGHT_BOLD,
      fontFamily: "Comfortaa",
    },
    body: {
      fontSize: AppTextsFontSize.SIZE_BODY,
      fontWeight: AppTextsFontWeight.WEIGHT_LIGHT,
      fontFamily: "Comfortaa",
    },
    body_card: {
      fontSize: AppTextsFontSize.SIZE_BODY,
      fontWeight: AppTextsFontWeight.WEIGHT_LIGHT,
    },
    body_drawer: {
      fontSize: AppTextsFontSize.SIZE_SUBTEXT,
      fontWeight: AppTextsFontWeight.WEIGHT_BOLD,
      fontFamily: "Comfortaa",
      color: AppColors.PRIMARY,
    },
    body_breadcrumbs: {
      fontSize: AppTextsFontSize.SIZE_SUBTITLE,
      fontWeight: AppTextsFontWeight.WEIGHT_LIGHT,
      fontFamily: "Comfortaa",
    },
    body_medium: {
      fontSize: AppTextsFontSize.SIZE_BODY,
      fontWeight: AppTextsFontWeight.WEIGHT_MEDIUM,
      fontFamily: "Comfortaa",
    },
    body_bold: {
      fontSize: AppTextsFontSize.SIZE_BODY,
      fontWeight: AppTextsFontWeight.WEIGHT_BOLD,
      fontFamily: "Comfortaa",
    },
    body_subtext: {
      fontSize: AppTextsFontSize.SIZE_SUBTEXT,
    },
    button_text: {
      fontSize: AppTextsFontSize.SIZE_BODY,
      fontFamily: "Comfortaa",
    },
    menu_list_text: {
      fontSize: AppTextsFontSize.SIZE_BODY,
      fontWeight: AppTextsFontWeight.WEIGHT_BOLD,
      fontFamily: "Comfortaa",
      color: AppColors.PRIMARY,
    },
    input_error: {
      fontSize: AppTextsFontSize.SIZE_SUBTEXT,
      color: AppColors.RED,
    }
  }
});

export default useCustomTypography